export default __webpack_public_path__ + "static/media/map_benlux.e4fb0a1d.png";